import { UpdateBlockStylesCommand } from '../UndoRedo/UpdateBlockStylesCommand.ts';
import { useCallback } from 'react';
import type { BlockSettings } from '../grid/reduxStore/blockStyleSettingsSlice.ts';
import { UndoRedoManagerCommandVersion } from '../UndoRedo/UndoRedoManagerCommandVersion.ts';
import { useSocketClient } from '../../../providers/SocketContext.tsx';
import { useCurrentUser } from '../../../providers/UserProvider.tsx';
import { useAppDispatch } from '../grid/reduxStore/Store.ts';
import { useCheckDocumentLockStatus } from 'components/editor/hooks/useCheckDocumentLockStatus';

export function useNewBlockStylesChangedHandler() {
  const dispatch = useAppDispatch();
  const { data } = useCurrentUser();
  const userId = data.id;
  const { socketClient } = useSocketClient();
  const checkDocumentLockStatus = useCheckDocumentLockStatus();

  return useCallback(
    async (blockId: string, sectionId: string, previousStyles: BlockSettings, newStyles: BlockSettings): Promise<void> => {
      const command = new UpdateBlockStylesCommand(blockId, sectionId, previousStyles, newStyles, {
        dispatch,
        socketClient,
        userId,
        checkDocumentLockStatus,
      });

      const success = await command.execute();
      if (success) {
        const undoRedoManager = UndoRedoManagerCommandVersion.getUndoRedoManager();
        undoRedoManager.pushUndoRedoCommands(command);
      }
    },
    [dispatch, socketClient, userId, checkDocumentLockStatus]
  );
}
